export const translations = {
    UY: {
      "agenda": "agendá",
      "agrupa": "agrupá",
      "ahorra": "ahorrá",
      "alquila": "alquilá",
      "alquiler": "alquiler",
      "amenities": "amenities",
      "area": "metraje",
      "asegura": "asegurá",
      "asigna": "asigná",
      "aumenta": "aumentá",
      "brinda": "brindá",
      "busca": "buscá",
      "buscas": "buscás",
      "codigo": "referencia",
      "city": "Ciudad",
      "commune": "Comuna",
      "completa": "completá",
      "compra": "comprá",
      "conoce": "conocé",
      "construidos_tipologias": "edificados",
      "construidos": "edificados",
      "consulta": "consultá",
      "contáctanos":"contactános",
      "contactar": "contactar",
      "coordina": "coordiná",
      "descarga": "descargá",
      "descubre": "descubrí",
      "dibuja": "dibujá",
      "elije": "elegí",
      "empieza": "empezá",
      "encuentra": "encontrá",
      "eres": "sos",
      "filtra": "filtrá",
      "finca":"chacra",
      "floor_1_to_5": "1er piso al 5to",
      "floor_6_to_10": "6to al 10mo piso",
      "floor_above_10": "+10mo piso",
      "floor_ground": "Planta Baja",
      "floor_penthouse": "Penthouse",
      "ganar": "ganá",
      "garage": "garage",
      "garaje o cochera": "garage o cochera",
      "gastosComunes": "gastos comunes",
      "gastosComunesShort": "GC",
      "gastosComunesDesc": "Gastos comunes incluidos",
      "guarda": "guardá",
      "hab": "dorm",
      "habitacion": "dormitorio",
      "habitaciones": "dormitorios",
      "habs": "dorms",
      "haz": "hacé",
      "ingresa": "ingresá",
      "llama": "llamá",
      "llega": "llegá",
      "llevar": "llevá",
      "locality": "Localidad",
      "mejora": "mejorá",
      "mira": "mirá",
      "mono": "mono",
      "nececitas": "necesitás",
      "neighbourhood": "Barrio",
      "nuevo": "a estrenar",
      "obten": "obtené",
      "optimiza": "optimizá",
      "planos": "en pozo",
      "property_type":"Tipo de Propiedad",
      "publica": "publicá",
      "puedes": "podés",
      "quieres": "querés",
      "recibe": "recibí",
      "recuerdas": "recordás",
      "registra": "registrá",
      "revisa": "revisá",
      "sabes": "sabés",
      "selecciona": "seleccioná",
      "sigue": "seguí",
      "siguenos": "seguinos",
      "solicita": "solicitá",
      "state": "Departamento",
      "sube": "subí",
      "supervisa": "supervisá",
      "terreno": "terreno",
      "ti": "vos",
      "tienes": "tenés",
      "totales_tipologias": "totales",
      "totales": "totales",
      "transacción":"tipo de operación",
      "tu": "vos",
      "unidades":"unidades",
    },
    CO: {
      "agenda": "agenda",
      "agrupa": "agrupa",
      "ahorra": "ahorra",
      "alquila": "alquila",
      "alquiler": "arriendo",
      "amenities": "características",
      "area": "área",
      "asegura": "asegura",
      "asigna": "asigna",
      "aumenta": "aumenta",      
      "brinda": "brinda",
      "busca": "busca",
      "buscas": "buscas",
      "codigo": "código",
      "city": "Ciudad",
      "commune": "Comuna",
      "completa": "completa",
      "compra": "compra",
      "conoce": "conoce",
      "construidos_tipologias": "privados",
      "construidos": "privada",
      "consulta": "consulta",
      "contáctanos":"contáctanos",
      "contactar": "contactar",
      "coordina": "coordina",
      "descarga": "descarga",
      "descubre": "descubre",
      "dibuja": "dibuja",
      "elije": "elije",
      "empieza": "empieza",
      "encuentra": "encuentra",
      "eres": "eres",
      "filtra": "filtra",
      "finca":"finca",
      "floor_1_to_5": "2do al 5to piso",
      "floor_6_to_10": "6to al 10mo piso",
      "floor_above_10": "+10mo piso",
      "floor_ground": "Primer Piso",
      "floor_penthouse": "Penthouse",
      "gana": "gana",
      "garage": "parqueadero",
      "garaje o cochera": "parqueadero",
      "gastosComunes": "administración",
      "gastosComunesShort": "admin",
      "gastosComunesDesc": "Gastos comunes incluidos",
      "guarda": "guarda",
      "hab" : "hab",
      "habitacion": "habitación",
      "habitaciones": "habitaciones",
      "habs" : "habs",
      "haz": "haz",
      "ingresa": "ingresa",
      "llama": "llama",
      "llega": "llega",
      "lleva": "lleva",
      "locality": "Localidad",
      "mejora": "mejora",
      "mira": "mira",
      "mono": "abierto",
      "nececitas": "nececitas",
      "neighbourhood": "Barrio",
      "nuevo": "nuevos",
      "obten": "obten",
      "optimiza": "optimiza",
      "planos": "sobre planos",
      "property_type":"Tipo de Inmueble",
      "publica": "publica",
      "puedes": "puedes",
      "quieres": "quieres",
      "recibe": "recibe",
      "recuerdas": "recuerdas",
      "registra": "registra",
      "revisa": "revisa",
      "sabes": "sabes",
      "selecciona": "selecciona",
      "sigue": "sigue",
      "siguenos": "siguenos",
      "solicita": "solicita",
      "state": "Departamento",
      "sube": "sube",
      "supervisa": "supervisa",
      "terreno": "lote",
      "ti": "ti",
      "tienes": "tienes",
      "totales_tipologias": "construidos",
      "totales": "construida",
      "transacción":"tipo de oferta",
      "tu": "tu",
      "unidades":"tipos",
    },
    PE: {
      "agenda": "agenda",
      "agrupa": "agrupa",
      "ahorra": "ahorra",
      "alquila": "alquila",
      "alquiler": "arriendo",
      "amenities": "características",
      "area": "área",
      "asegura": "asegura",
      "asigna": "asigna",
      "aumenta": "aumenta",      
      "brinda": "brinda",
      "busca": "busca",
      "buscas": "buscas",
      "codigo": "referencia",
      "city": "Ciudad",
      "commune": "Comuna",
      "completa": "completa",
      "compra": "compra",
      "conoce": "conoce",
      "construidos_tipologias": "construida",
      "construidos": "construida",
      "consulta": "consulta",
      "contáctanos":"contáctanos",
      "contactar": "contactar",
      "coordina": "coordina",
      "descarga": "descarga",
      "descubre": "descubre",
      "dibuja": "dibuja",
      "elije": "elije",
      "empieza": "empieza",
      "encuentra": "encuentra",
      "eres": "eres",
      "filtra": "filtra",
      "finca":"chacra",
      "floor_1_to_5": "2do al 5to piso",
      "floor_6_to_10": "6to al 10mo piso",
      "floor_above_10": "+10mo piso",
      "floor_ground": "Primer Piso",
      "floor_penthouse": "Penthouse",
      "gana": "gana",
      "garage": "parqueadero",
      "garaje o cochera": "parqueadero",
      "gastosComunes": "mantenimiento",
      "gastosComunesShort": "mant.",
      "gastosComunesDesc": "Mantenimiento incluido",
      "guarda": "guarda",
      "hab" : "dorm",
      "habitacion": "dormitorio",
      "habitaciones": "dormitorios",
      "habs": "dorms",
      "haz": "haz",
      "ingresa": "ingresa",
      "llama": "llama",
      "llega": "llega",
      "lleva": "lleva",
      "locality": "Localidad",
      "mejora": "mejora",
      "mira": "mira",
      "mono": "abierto",
      "nececitas": "nececitas",
      "neighbourhood": "Barrio",
      "nuevo": "nuevos",
      "obten": "obten",
      "optimiza": "optimiza",
      "planos": "sobre planos",
      "property_type":"Tipo de Inmueble",
      "publica": "publica",
      "puedes": "puedes",
      "quieres": "quieres",
      "recibe": "recibe",
      "recuerdas": "recuerdas",
      "registra": "registra",
      "revisa": "revisa",
      "sabes": "sabes",
      "selecciona": "selecciona",
      "sigue": "sigue",
      "siguenos": "siguenos",
      "solicita": "solicita",
      "state": "Estado",
      "sube": "sube",
      "supervisa": "supervisa",
      "terreno": "terreno",
      "ti": "ti",
      "tienes": "tienes",
      "totales_tipologias": "totales",
      "totales": "totales",
      "transacción":"tipo de oferta",
      "tu": "tu",
      "unidades":"tipos",
    },
    PY: {
      "agenda": "agendá",
      "agrupa": "agrupá",
      "ahorra": "ahorrá",
      "alquila": "alquilá",
      "alquiler": "alquiler",
      "amenities": "amenities",
      "area": "metraje",
      "asegura": "asegurá",
      "asigna": "asigná",
      "aumenta": "aumentá",
      "brinda": "brindá",
      "busca": "buscá",
      "buscas": "buscás",
      "codigo": "referencia",
      "city": "Ciudad",
      "commune": "Comuna",
      "completa": "completá",
      "compra": "comprá",
      "conoce": "conocé",
      "construidos_tipologias": "construida",
      "construidos": "construida",
      "consulta": "consultá",
      "contáctanos":"contáctanos",
      "contactar": "contactar",
      "coordina": "coordiná",
      "descarga": "descargá",
      "descubre": "descubrí",
      "dibuja": "dibujá",
      "elije": "elegí",
      "empieza": "empezá",
      "encuentra": "encontrá",
      "eres": "sos",
      "filtra": "filtrá",
      "finca":"chacra",
      "floor_1_to_5": "1er piso al 5to",
      "floor_6_to_10": "6to al 10mo piso",
      "floor_above_10": "+10mo piso",
      "floor_ground": "Planta Baja",
      "floor_penthouse": "Penthouse",
      "gana": "gana",
      "garage": "parqueadero",
      "garaje o cochera": "parqueadero",
      "gastosComunes": "gastos comunes",
      "gastosComunesShort": "GC",
      "gastosComunesDesc": "Gastos comunes incluidos",
      "guarda": "guardá",
      "hab": "dorm",
      "habitacion": "dormitorio",
      "habitaciones": "dormitorios",
      "habs": "dorms",
      "haz": "haz",
      "ingresa": "ingresá",
      "llama": "llamá",
      "llega": "llegá",
      "lleva": "llevá",
      "locality": "Localidad",
      "mejora": "mejorá",
      "mira": "mirá",
      "mono": "abierto",
      "nececitas": "nececitás",
      "neighbourhood": "Barrio",
      "nuevo": "nuevos",
      "obten": "obtené",
      "optimiza": "optimizá",
      "planos": "sobre planos",
      "property_type":"Tipo de Propiedad",
      "publica": "publicá",
      "puedes": "podés",
      "quieres": "querés",
      "recibe": "recibí",
      "recuerdas": "recordás",
      "registra": "registrá",
      "revisa": "revisá",
      "sabes": "sabés",
      "selecciona": "seleccioná",
      "sigue": "seguí",
      "siguenos": "seguinos",
      "solicita": "solicitá",
      "state": "Estado",
      "sube": "sube",
      "supervisa": "supervisa",
      "terreno": "terreno",
      "ti": "ti",
      "tienes": "tenés",
      "totales_tipologias": "totales",
      "totales": "totales",
      "transacción":"tipo de operación",
      "tu": "vos",
      "unidades":"tipos",
    },
    BO: {
      "agenda": "agendá",
      "agrupa": "agrupá",
      "ahorra": "ahorrá",
      "alquila": "alquilá",
      "alquiler": "alquiler",
      "amenities": "amenities",
      "area": "metraje",
      "asegura": "asegurá",
      "asigna": "asigná",
      "aumenta": "aumentá",
      "brinda": "brindá",
      "busca": "buscá",
      "buscas": "buscás",
      "codigo": "referencia",
      "city": "Ciudad",
      "commune": "Comuna",
      "completa": "completá",
      "compra": "comprá",
      "conoce": "conocé",
      "construidos_tipologias": "edificados",
      "construidos": "edificados",
      "consulta": "consultá",
      "contáctanos":"contactános",
      "contactar": "contactar",
      "coordina": "coordiná",
      "descarga": "descargá",
      "descubre": "descubrí",
      "dibuja": "dibujá",
      "elije": "elegí",
      "empieza": "empezá",
      "encuentra": "encontrá",
      "eres": "sos",
      "filtra": "filtrá",
      "finca":"chacra",
      "floor_1_to_5": "1er piso al 5to",
      "floor_6_to_10": "6to al 10mo piso",
      "floor_above_10": "+10mo piso",
      "floor_ground": "Planta Baja",
      "floor_penthouse": "Penthouse",
      "ganar": "ganá",
      "garage": "garage",
      "garaje o cochera": "garage o cochera",
      "gastosComunes": "gastos comunes",
      "gastosComunesShort": "GC",
      "gastosComunesDesc": "Gastos comunes incluidos",
      "guarda": "guardá",
      "hab": "dorm",
      "habitacion": "dormitorio",
      "habitaciones": "dormitorios",
      "habs": "dorms",
      "haz": "hacé",
      "ingresa": "ingresá",
      "llama": "llamá",
      "llega": "llegá",
      "llevar": "llevá",
      "locality": "Localidad",
      "mejora": "mejorá",
      "mira": "mirá",
      "mono": "mono",
      "nececitas": "necesitás",
      "neighbourhood": "Barrio",
      "nuevo": "a estrenar",
      "obten": "obtené",
      "optimiza": "optimizá",
      "planos": "en pozo",
      "property_type":"Tipo de Propiedad",
      "publica": "publicá",
      "puedes": "podés",
      "quieres": "querés",
      "recibe": "recibí",
      "recuerdas": "recordás",
      "registra": "registrá",
      "revisa": "revisá",
      "sabes": "sabés",
      "selecciona": "seleccioná",
      "sigue": "seguí",
      "siguenos": "seguinos",
      "solicita": "solicitá",
      "state": "Departamento",
      "sube": "subí",
      "supervisa": "supervisá",
      "terreno": "terreno",
      "ti": "vos",
      "tienes": "tenés",
      "totales_tipologias": "totales",
      "totales": "totales",
      "transacción":"tipo de operación",
      "tu": "vos",
      "unidades":"unidades",
    },
    CL: {
      "agenda": "agenda",
      "agrupa": "agrupa",
      "ahorra": "ahorra",
      "alquila": "alquila",
      "alquiler": "arriendo",
      "amenities": "características",
      "area": "área",
      "asegura": "asegura",
      "asigna": "asigna",
      "aumenta": "aumenta",      
      "brinda": "brinda",
      "busca": "busca",
      "buscas": "buscas",
      "codigo": "referencia",
      "city": "Ciudad",
      "commune": "Comuna",
      "completa": "completa",
      "compra": "compra",
      "conoce": "conoce",
      "construidos_tipologias": "construida",
      "construidos": "construida",
      "consulta": "consulta",
      "contáctanos":"contáctanos",
      "contactar": "contactar",
      "coordina": "coordina",
      "descarga": "descarga",
      "descubre": "descubre",
      "dibuja": "dibuja",
      "elije": "elije",
      "empieza": "empieza",
      "encuentra": "encuentra",
      "eres": "eres",
      "filtra": "filtra",
      "finca":"chacra",
      "floor_1_to_5": "2do al 5to piso",
      "floor_6_to_10": "6to al 10mo piso",
      "floor_above_10": "+10mo piso",
      "floor_ground": "Primer Piso",
      "floor_penthouse": "Penthouse",
      "gana": "gana",
      "garage": "parqueadero",
      "garaje o cochera": "parqueadero",
      "gastosComunes": "administración",
      "gastosComunesShort": "admin",
      "guarda": "guarda",
      "hab" : "hab",
      "habitacion": "habitación",
      "habitaciones": "habitaciones",
      "habs" : "habs",
      "haz": "haz",
      "ingresa": "ingresa",
      "llama": "llama",
      "llega": "llega",
      "lleva": "lleva",
      "locality": "Localidad",
      "mejora": "mejora",
      "mira": "mira",
      "mono": "abierto",
      "nececitas": "nececitas",
      "neighbourhood": "Barrio",
      "nuevo": "nuevos",
      "obten": "obten",
      "optimiza": "optimiza",
      "planos": "sobre planos",
      "property_type":"Categoría",
      "publica": "publica",
      "puedes": "puedes",
      "quieres": "quieres",
      "recibe": "recibe",
      "recuerdas": "recuerdas",
      "registra": "registra",
      "revisa": "revisa",
      "sabes": "sabes",
      "selecciona": "selecciona",
      "sigue": "sigue",
      "siguenos": "siguenos",
      "solicita": "solicita",
      "state": "Estado",
      "sube": "sube",
      "supervisa": "supervisa",
      "terreno": "terreno",
      "ti": "ti",
      "tienes": "tienes",
      "totales_tipologias": "totales",
      "totales": "totales",
      "transacción":"tipo de oferta",
      "tu": "tu",
      "unidades":"tipos",
    },
    ce3: {
      "agenda": "agendá",
      "agrupa": "agrupá",
      "ahorra": "ahorrá",
      "alquila": "alquilá",
      "alquiler": "alquiler",
      "amenities": "amenities",
      "area": "metraje",
      "asegura": "asegurá",
      "asigna": "asigná",
      "aumenta": "aumentá",
      "brinda": "brindá",
      "codigo": "referencia",
      "busca": "buscá",
      "buscas": "buscás",
      "city": "Ciudad",
      "commune": "Comuna",
      "completa": "completá",
      "compra": "comprá",
      "conoce": "conocé",
      "construidos_tipologias": "edificados",
      "construidos": "edificados",
      "consulta": "consultá",
      "contáctanos":"contactános",
      "contactar": "contactar",
      "coordina": "coordiná",
      "descarga": "descargá",
      "descubre": "descubrí",
      "dibuja": "dibuja",
      "elije": "elegí",
      "empieza": "empezá",
      "encuentra": "encontrá",
      "eres": "sos",
      "filtra": "filtrá",
      "finca":"chacra",
      "floor_1_to_5": "1er piso al 5to",
      "floor_6_to_10": "6to al 10mo piso",
      "floor_above_10": "+10mo piso",
      "floor_ground": "Planta Baja",
      "floor_penthouse": "Penthouse",
      "ganar": "ganá",
      "garage": "garage",
      "garaje o cochera": "garage o cochera",
      "gastosComunes": "gastos comunes",
      "gastosComunesShort": "GC",
      "guarda": "guardá",
      "hab": "dorm",
      "habitacion": "dormitorio",
      "habitaciones": "dormitorios",
      "habs": "dorms",
      "haz": "hacé",
      "ingresa": "ingresá",
      "llama": "llamá",
      "llega": "llegá",
      "llevar": "llevá",
      "locality": "Localidad",
      "mejora": "mejorá",
      "mira": "mirá",
      "mono": "mono",
      "nececitas": "necesitás",
      "neighbourhood": "Barrio",
      "nuevo": "a estrenar",
      "obten": "obtené",
      "optimiza": "optimizá",
      "planos": "en pozo",
      "property_type":"Tipo de Propiedad",
      "publica": "publicá",
      "puedes": "podés",
      "quieres": "querés",
      "recibe": "recibí",
      "recuerdas": "recordás",
      "registra": "registrá",
      "revisa": "revisá",
      "sabes": "sabés",
      "selecciona": "seleccioná",
      "sigue": "seguí",
      "siguenos": "seguinos",
      "solicita": "solicitá",
      "state": "Estado",
      "sube": "subí",
      "supervisa": "supervisá",
      "terreno": "terreno",
      "ti": "vos",
      "tienes": "tenés",
      "totales_tipologias": "totales",
      "totales": "totales",
      "transacción": "tipo de operación",
      "tu": "vos",
      "unidades":"unidades",
    },
    // Set translations to avoid wrong texts, the first render always show uy translations
    DEFAULT:{
      "busca": "busca",
      "city": "Ciudad",
      "commune": "Comuna",
      "completa": "completa",
      "contáctanos":"contáctanos",
      "descarga": "descarga",
      "dibuja": "dibuja",
      "habitaciones": "....",
      "locality": "Localidad",
      "neighbourhood": "Barrio",
      "property_type":"Tipo de Propiedad",
      "siguenos": "siguenos",
      "state": "Estado",
    }
};